import React, { useEffect, useState } from 'react';

import { useQueryClient } from 'react-query';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useMutationSetProjectIsShowPredictionLikelihood } from 'api/mutations/setProjectIsShowPredictionLikelihood.mutation';

import { Switch } from 'components/DesignSystem/Switch';
import { ConfirmSaveModal } from 'components/common';

interface Props {
    isShow: boolean;
    projectId: number;
}

export const ShowPredictionLikelihood = ({ isShow, projectId }: Props) => {
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
    const { handleSnackBar } = useCustomSnackBar();
    const [showPredictionLikelihood, setShowPredictionLikelihood] = useState<boolean>(isShow);
    const setIsShowPredictionLikelihoodForProject = useMutationSetProjectIsShowPredictionLikelihood();
    const queryClient = useQueryClient();

    // persist the selection and close the confirmation
    const handleSave = () => {
        setIsShowPredictionLikelihoodForProject.mutate(
            { status: showPredictionLikelihood, projectId },
            {
                onSuccess: () => {
                    const queryKey = ['getIsShowPredictionLikelihoodForProject', projectId];
                    queryClient.invalidateQueries(queryKey);
                    handleSnackBar(
                        showPredictionLikelihood
                            ? 'prediction likelihood will be shown'
                            : 'prediction likelihood will be hidden',
                        'success',
                    );
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    setShowConfirmModal(false);
                },
            },
        );
    };

    // revert to original value( isShow) and close the confirmation
    const handleCancel = () => {
        setShowPredictionLikelihood(isShow);
        setShowConfirmModal(false);
    };

    return (
        <>
            <span>Show Planned Finish Likelihood:</span>
            <Switch
                id={'prediction-likelihood-switch'}
                checked={showPredictionLikelihood}
                onChange={(e) => {
                    setShowPredictionLikelihood(e.target.checked);
                    setShowConfirmModal(true);
                }}
            />
            <ConfirmSaveModal
                isShowModal={showConfirmModal}
                onHideModal={handleCancel}
                onConfirm={handleSave}
                isLoading={setIsShowPredictionLikelihoodForProject.isLoading}
            >
                You have made changes. Would you like to save them?
            </ConfirmSaveModal>
        </>
    );
};
